import { Box, Flex, Image, Text } from '@chakra-ui/react'

const Requirement = () => {
  return (
    <Box className="rounded-2xl border-2 border-[#DDDDDD]">
      <div className="h-4 w-full rounded-t-2xl bg-[#ED837F]"></div>

      <Flex className="mb-3 flex-col gap-5 p-4">
        <Flex className="flex-col">
          <Image
            src={'/rewards/fingerprint.svg'}
            alt="Icon"
            w={8}
            h={8}
            mb={1}
          />
          <Text className="my-1 text-[16px] font-semibold text-[#ED837F]">
            {/* Earning Requirement */}
            Watch Time Earnings Requirement
          </Text>
          <Text
            lineHeight={'normal'}
            className="mb-1.5 text-sm font-normal text-[#656565]"
          >
            You can only earn from your watch time if you are logged in.
          </Text>
        </Flex>

        <Flex className="flex-col">
          <Image src={'/rewards/profile.svg'} alt="Icon" w={7} h={7} mb={1} />
          <Text className="my-1 text-[16px] font-semibold text-[#ED837F]">
            Withdrawal Verification
          </Text>
          <Text
            lineHeight={'normal'}
            className="mb-1.5 text-sm font-normal text-[#656565]"
          >
            Identity and profile verification is needed for withdrawal of LYK
            Coins.
          </Text>
        </Flex>

        <Flex className="flex-col">
          <Image
            src={'/rewards/exclamationMark.svg'}
            alt="Icon"
            w={7}
            h={7}
            mb={1}
          />
          <Text className="my-1 text-[16px] font-semibold text-[#ED837F]">
            {/* Earnings Limitation */}
            Watch Time Earnings Limitation
          </Text>
          <Text
            lineHeight={'normal'}
            className="mb-1.5 text-sm font-normal text-[#656565]"
          >
            {/* Skipping ads means no earnings - earning is based on ad revenue. */}
            Skipping ads means no Watch Time Earnings - Watch Time Earnings is based on ad revenue.
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Requirement
